// create a service that fetches movies from the API:
import {REACT_APP_THE_MOVIE_DB_API_KEY, REACT_APP_THE_MOVIE_DB_API_URL} from '@env';

const searchMovies = async (searchTerm) => {
  const url = `${REACT_APP_THE_MOVIE_DB_API_URL}/search/movie?api_key=${REACT_APP_THE_MOVIE_DB_API_KEY}&query=${searchTerm}`;
  const response = await fetch(url);
  const data = await response.json();
  return data.results;
}

const getMovie = async (movieId) => {
  const url = `${REACT_APP_THE_MOVIE_DB_API_URL}/movie/${movieId}?api_key=${REACT_APP_THE_MOVIE_DB_API_KEY}`;
    const response = await fetch(url);
    const data = await response.json();
    return data;
}

export {searchMovies, getMovie};
